import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
} from 'lucide-react'
import { memo, type ReactNode } from 'react'

import { DataTablePaginationButton } from './data-table-pagination-button.atom'

interface DataTablePaginationControlsProps {
  currentPage: number
  totalPages: number
  isFirstPage: boolean
  isLastPage: boolean
  onFirstPage: () => void
  onPrevPage: () => void
  onNextPage: () => void
  onLastPage: () => void
}

/**
 * Renders pagination navigation buttons for first, previous, next, and last page.
 */
const DataTablePaginationControlsBase: React.FC<DataTablePaginationControlsProps> = ({
  currentPage,
  totalPages,
  isFirstPage,
  isLastPage,
  onFirstPage,
  onPrevPage,
  onNextPage,
  onLastPage,
}): ReactNode => (
  <div className="data-table-pagination-controls flex items-center gap-1">
    <DataTablePaginationButton
      icon={ChevronsLeftIcon}
      label="First page"
      isDisabled={isFirstPage}
      onClick={onFirstPage}
      className="data-table-pagination-first size-8"
    />
    <DataTablePaginationButton
      icon={ChevronLeftIcon}
      label="Previous page"
      isDisabled={isFirstPage}
      onClick={onPrevPage}
      className="data-table-pagination-prev size-8"
    />
    <span className="data-table-pagination-text mx-2 text-sm text-muted-foreground">
      Page {currentPage} of {totalPages}
    </span>
    <DataTablePaginationButton
      icon={ChevronRightIcon}
      label="Next page"
      isDisabled={isLastPage}
      onClick={onNextPage}
      className="data-table-pagination-next size-8"
    />
    <DataTablePaginationButton
      icon={ChevronsRightIcon}
      label="Last page"
      isDisabled={isLastPage}
      onClick={onLastPage}
      className="data-table-pagination-last size-8"
    />
  </div>
)

export const DataTablePaginationControls = memo(DataTablePaginationControlsBase)

DataTablePaginationControls.displayName = 'DataTablePaginationControls'
